import { SVGViewerPill } from "./SVGViewerStyles";
import React from "react";
import { Dimensions, Position, ViewerLocation } from "./index";
import { MountType } from "../../../reducers/uploadedBoard";
import { xyformatting } from "../../../utils/valueFormatting";
import { EXPECTED_PLACEMENT_UNIT } from "../../ReviewBoardFlow/BillOfMaterials/SelectPart/UpdateElementPlacement";

export default function CursorLocation({
  cursorLocation,
  mountType,
  position,
  baseDimensions,
}: {
  cursorLocation: ViewerLocation;
  mountType: MountType;
  position: Position | null;
  baseDimensions: Dimensions | null;
}) {
  if (position === null || baseDimensions === null) {
    return null;
  }

  const x =
    mountType == MountType.TOP
      ? baseDimensions.minX + (cursorLocation.x - position.x) / position.zoom
      : baseDimensions.width +
        baseDimensions.minX -
        (cursorLocation.x - position.x) / position.zoom;

  const y =
    baseDimensions.minY +
    baseDimensions.height +
    (position.y - cursorLocation.y) / position.zoom;

  return (
    <SVGViewerPill viewOnly>
      {xyformatting(x, y, EXPECTED_PLACEMENT_UNIT)}
    </SVGViewerPill>
  );
}
